import {
  Box,
  Dialog,
  DialogTitle,
  Typography,
  DialogActions,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { appThemes, useMeetingAppContext } from "../MeetingAppContextDef";

const DarkCustomButton = styled(Button)`
  border-radius: 0.8vh;
  &:hover {
    color: white;
    background: #2b2e32;
  }
`;

const DarkOutlinedButton = styled(Button)`
  border-radius: 0.8vh;
  &:hover {
    color: white;
    background: #2b2e32;
    border: 0.2vh solid white !important;
  }
`;

const DarkDangerButton = styled(Button)`
  border-radius: 0.8vh;
  background: #FF2828CC;
  color: white;
  &:hover {
    background: #ff2828;
    color: white;
  }
  &:active {
    filter: brightness(0.95);
  }
`;

const LightCustomButton = styled(Button)`
  border-radius: 0.8vh;
  &:hover {
    background: #eef0f2;
  }
`;

const LightOutlinedButton = styled(Button)`
  border-radius: 0.8vh;
  &:hover {
    background: #eef0f2;
    border: 0.2vh solid #404b53 !important;
  }
`;

const LightDangerButton = styled(Button)`
  border-radius: 0.8vh;
  background: #FF2828CC;
  color: white;
  &:hover {
    background: #ff2828;
    color: white;
  }
  &:active {
    filter: brightness(0.95);
  }
`;
const ConfirmBox = ({
  successText,
  rejectText,
  onSuccess,
  open,
  onReject,
  title,
  subTitle,
  subTitleColor,
  appTheme,
  isDestructive = false, // New prop for destructive actions
}) => {
  const v = useMeetingAppContext();

  const theme = useTheme();

  if (v && v?.isRecorder) {
    return <></>;
  }

  const ButtonElement =
    ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
      ? LightCustomButton
      : DarkCustomButton;

  const OutlinedButtonElememt = isDestructive
    ? ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
      ? LightDangerButton
      : DarkDangerButton
    : ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
      ? LightOutlinedButton
      : DarkOutlinedButton;

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={() => {}}
      aria-labelledby="responsive-dialog-title"
    >
      <Box
        style={{
          padding: "1.5vh",
          backgroundColor:
            ((v && v?.appTheme) || appTheme) === appThemes.DARK
              ? theme.palette.darkTheme.slightLighter
              : ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
              ? theme.palette.lightTheme.main
              : theme.palette.background.default,
        }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <DialogTitle
              style={{
                padding: "1.2vh 1.6vh",
                margin: 0,
                width: "100%",
                color:
                  ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
                    ? "#95959E"
                    : "#fff",
              }}
              id="responsive-dialog-title"
            >
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: "bold",
                  fontSize: "2vh",
                  color:
                    ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
                      ? "#404B53"
                      : "#fff",
                }}
              >
                {title}
              </Typography>
              {subTitle && (
                <Typography
                  variant="body2"
                  style={{
                    marginTop: "0.8vh",
                    fontSize: "1.6vh",
                    color: subTitleColor
                      ? subTitleColor
                      : ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
                      ? theme.palette.lightTheme.five
                      : "#9FA0A7",
                  }}
                >
                  {subTitle}
                </Typography>
              )}
            </DialogTitle>
          </Box>
        </Box>
        <Box>
          <DialogActions
            style={{
              padding: "0.8vh 1.6vh 1.2vh",
              gap: "1vh",
            }}
          >
            <ButtonElement
              onClick={onReject}
              sx={{
                color:
                  ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
                    ? "#95959E"
                    : "white",
                padding: "1vh 2.4vh",
                fontSize: "1.6vh",
                textTransform: "none",
                minWidth: "10vh",
                border: "none",
                "&:hover": {
                  backgroundColor:
                    ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
                      ? "#eef0f2"
                      : "#2b2e32",
                },
              }}
            >
              {rejectText}
            </ButtonElement>

            <OutlinedButtonElememt
              onClick={onSuccess}
              sx={{
                color: "white",
                padding: "1vh 2.4vh",
                fontSize: "1.6vh",
                textTransform: "none",
                minWidth: "10vh",
                border: "none",
                backgroundColor: isDestructive
                  ? theme.palette.error.main
                  : ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
                  ? "#95959E"
                  : "white",
                "&:hover": {
                  backgroundColor: isDestructive
                    ? "#B71C1C"
                    : ((v && v?.appTheme) || appTheme) === appThemes.LIGHT
                    ? "#7a7a7a"
                    : "#e0e0e0",
                },
              }}
              autoFocus
            >
              {successText}
            </OutlinedButtonElememt>
          </DialogActions>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ConfirmBox;
